module.exports = __webpack_public_path__ + "img/location10072.22ddd8c9.png";